import React from 'react'
import { connect } from 'react-redux'
import { loadMonster } from '../../../../actions'
import MonsterV1_2 from './MonsterV1_2'
import MonsterV1_3 from './MonsterV1_3'

import './Monster.css'

const RENDERERS = {
    '1.2': MonsterV1_2,
    '1.3': MonsterV1_3,
}

function getSchemaVersionOverride() {
    const params = new URLSearchParams(window.location.search)
    const urlVersion = params.get('schema_version')
    if (urlVersion) return urlVersion

    try {
        const lsVersion = localStorage.getItem('pfsrd2_schema_version_override')
        if (lsVersion) return lsVersion
    } catch (e) {
        // localStorage may be unavailable
    }

    return null
}

const Monster = props => {
    const { data, token, gameId, loadMonster } = props

    if (!data) {
        return null
    }

    const override = getSchemaVersionOverride()
    const version = override || String(data.schema_version)
    const Renderer = RENDERERS[version]

    if (Renderer) {
        return <Renderer data={data} token={token} gameId={gameId} onLoadMonster={loadMonster} />
    }

    return (
        <div className='Monster'>
          <h1>Cannot Render Creature</h1>
          Monster has a schema version that is not supported by this version of the app.<br/>
          Schema version: {data.schema_version}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        data: state.monsters.loadedMonster,
        token: state.client.token,
        gameId: state.game.id,
    }
}

const mapDispatchToProps = { loadMonster }

export default connect(mapStateToProps, mapDispatchToProps)(Monster)
